import type { IconSvgObject } from './types';

const FileNotFoundIcon: IconSvgObject = [
  ["path", { d: "M15 15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.02496 2H17.9969C19.1014 2 19.9969 2.89543 19.9969 4V15.0145L19.5052 15.5052M4.02496 3.99688L4 19.9984C3.99828 21.1042 4.89421 22.0015 6 22.0015H12.9955L17.5031 17.5031", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileNotFoundIcon;
